import { ActionBrick, registerBrick, File, Transaction, CloudObject, ErrorFlow } from 'olympe';
import {getLogger} from "@olympeio/core";
import {ImageCapture as IC} from 'image-capture'; // Adding polyfill for safari & firefox


export default class TakePicture extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} videoStream
     * @param {boolean} saveFile
     * @param {number} width
     * @param {number} height
     * @param {function()} forwardEvent
     * @param {function(File)} setPicture
     */
    async update($, [videoStream, saveFile, width, height], [forwardEvent, setPicture]) {
        const logger = getLogger('Take Picture')

        if (!videoStream.getVideoTracks()[0]) {
            throw ErrorFlow.create('No video stream found, is the camera capture allowed ?', 404);
        }

        const imageCapture = new ImageCapture(videoStream.getVideoTracks()[0]);
        const { imageWidth, imageHeight } = await imageCapture.getPhotoCapabilities();
        const setInRange = (value, range) => {
            if(!range) return NaN;
            let x = Math.min(range.max, Math.max(range.min, value));
            if (range.step > 0) {
                x = Math.round(x / range.step) * range.step;
            }
            return x;
        }

        const actualWidth = setInRange(width, imageWidth);
        const actualHeight = setInRange(height, imageHeight);
        const photoSettings = {
            imageWidth: actualWidth,
            imageHeight: actualHeight
        };


        try {
            const blob = await imageCapture.takePhoto(photoSettings);
            logger.debug("Took photo:", blob);

            const transaction = new Transaction(saveFile);
            const screenshotName = `picture_${Date.now()}_${actualWidth}x${actualHeight}`;
            const fileTag = File.createFromContent(transaction, screenshotName, blob, 'image/jpeg');
            await transaction.execute();

            setPicture(CloudObject.get(fileTag));
            forwardEvent();

        } catch(error) {
            throw ErrorFlow.create('takePhoto() error: '+ error, 1);
        }

    }
}

registerBrick('018dcaebfd906bfa455f', TakePicture);
